import classNames from 'classnames';
import { useField, ErrorMessage } from 'formik';
const Radios = ({ options, orientation, ...props }) => {
    const [field, meta] = useField(props);
    return (
        <div className="form__group" role="group" aria-label="radio buttons">
            <div
                className={classNames('form__validation', {
                    'form__validation--error': meta.touched && meta.error,
                })}
            >
                {options.map((option) => {
                    return (
                        <label key={option.value} className="form__item">
                            <input
                                className="form__selector"
                                type="radio"
                                {...field}
                                {...props}
                                checked={field.value === option.value}
                                value={option.value}
                            />
                            <div className="form__check form__check--radio"></div>
                            {option.label}
                        </label>
                    );
                })}
                <ErrorMessage
                    name={field.name}
                    render={(msg) => <div className="form__helper">{msg}</div>}
                />
            </div>
        </div>
    );
};

export default Radios;
